import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type {
  CollectionFinishedListResponseDto,
  WebCollectionFindOneOutputDto,
} from '@bldsoft/ovp-api-types'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'
import { payload } from '../../result'
import { format } from './format'

export function use(
  client: OvpClient,
  collections: API['collections'],
  _api: API,
  _defaults: AdapterDefaults
): void {
  // GET /api/web/collection/${id}
  collections.base.getOneFx.use(
    async ({ id, withContentTypes, withSeoMetadata }) => {
      const data = payload<WebCollectionFindOneOutputDto>(
        await client.get.api.web.collections(id)({
          query: { withContentTypes, withSeoMetadata },
        })
      )

      if (!data) {
        throw new Error('Empty answer in collections.base.getOneFx')
      }

      return format(data)
    }
  )

  // GET /api/web/collections
  collections.base.getManyFx.use(
    async ({
      ids,
      limit,
      offset,
      by = _defaults.sortBy,
      order = _defaults.sortOrder,
      q,
      hasContent,
    }) => {
      const data = payload<CollectionFinishedListResponseDto>(
        await client.get.api.web.collections({
          query: {
            ids,
            limit,
            offset,
            sortBy: by,
            sortOrder: order,
            q,
            hasContent,
          },
        })
      )

      if (!data) {
        throw new Error('Empty answer in collections.base.getManyFx')
      }

      return [...(data.results || [])].map(format)
    }
  )
}
